import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
  onAuthStateChanged,
  signOut,
  deleteUser,
} from 'firebase/auth'
import { getAPICallServer } from '../utils/axios.util'
import { apiServerRoutes } from '../constants/apiRoutes'
import { DEVICE_TYPE } from '../constants/general'

interface loginInterface {
  email: string
  password: string
  phone: string
  name: string
}

interface updateUserInterface {
  name: string
  phone: string
}

class authService {
  /**
   * @method: Method to create user into firebase
   * @param param1: User email, password
   */
  async signUpUser({ email, password, phone, name }: loginInterface) {
    const auth = getAuth()
    // create user
    const user = await createUserWithEmailAndPassword(auth, email, password)

    // create entry into database
    const payload = {
      email,
      name,
      firebase_id: user.user?.uid,
      mobile_number: phone,
    }

    // update user displayName into firebase
    await updateUserDetails({ phone, name })

    return payload
  }

  /**
   * @method: Method to login user into firebase
   * @param param1: User email, password
   */
  async signInUser({ email, password }: loginInterface) {
    const auth = getAuth()

    // signIn user with Firebase
    const userDetails: any = signInWithEmailAndPassword(auth, email, password)

    return userDetails
  }

  /**
   * To get the authentication token
   * @param fbId Is the firebase entry id
   */
  async getAuthToken(fbId: string, FCMToken: string | null) {
    return await getAPICallServer(
      `${apiServerRoutes.AUTH_TOKEN}?firebase_id=${fbId}&device_type=${DEVICE_TYPE}&app_version=1&device_token=${FCMToken}`,
    )
  }

  /**
   * @method: Method to logout user
   */
  async doLogout() {
    const auth: any = getAuth()
    return await signOut(auth)
  }

  async doLogoutWithRedirect() {
    const auth: any = getAuth()
    await signOut(auth)
    window.location.replace('/logout')
    return
  }

  async deleteUserFromFirebase() {
    const auth: any = getAuth()
    return await deleteUser(auth.currentUser)
  }
}

export default new authService()

/**
 * @method: Method to update user detail into firebase
 * @param param1: User name, phoneNumber
 */
export const updateUserDetails = async ({ name }: updateUserInterface) => {
  try {
    const auth: any = getAuth()
    await updateProfile(auth.currentUser, {
      displayName: name,
    })
    return { success: true }
  } catch (e: any) {
    return { success: false, message: e.message }
  }
}

/**
 * @method: Method to validate user authentication
 */
export const validateAuthentication = (callBack: any) => {
  try {
    const auth: any = getAuth()
    onAuthStateChanged(auth, callBack)
    return { success: true }
  } catch (e: any) {
    return { success: false, message: e.message }
  }
}
